import { render } from "./super-dashboard.vue?vue&type=template&id=48c6e106"
import script from "./super-dashboard.vue?vue&type=script&lang=js"
export * from "./super-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__